export interface IterableInAppResponse {
    status: RESPONSE_STATUS;
    inAppMessages: InAppMessage[];
}

export interface InAppMessage {
    messageId: string;
    campaignId?: string | number;
    createdAt: string;
    expiresAt: string;
    content: InAppContent;
    saveToInbox: boolean;
    inboxMetadata: InboxMetadata;
    customPayload: any;
    jsonOnly: boolean;
    read: boolean;

}

export interface IterableOpenMsgInAppResponse {
    msg?: string;
    code: string;
}

interface InAppContent {
    html: string;
    payload?:any;
}

export interface InboxMetadata {
    title: string;
    subtitle: string;
    icon: string;
}

export enum RESPONSE_STATUS {
    SUCCESS = 200,
    ERROR_PARAMS = 400,
    ERROR_API_KEY = 401
} 


// WEBPACK FOOTER //
// ./src/model/api/iterables/iterables-inapp-response.entity.interface.ts